<template>
  <div class="userBox">
    <div class="icon user"></div>
    <p class="username" v-if="isLogin">
      {{ username }}
    </p>
    <template v-if="!hideLogin">
      <span
        class="switchAccount"
        v-if="isLogin && !runInsdk()"
        href="javascript:void(0)"
        @click="handleLogout"
      >
        [ {{ $t("switchAccount") }} ]</span
      >
      <span
        href="javascript:void(0)"
        v-if="!isLogin"
        class="login"
        @click="handleJumpLogin"
        >{{ $t("login") }}</span
      >
  </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { runInsdk } from "@/utils/index";
import { LOGOUT, JUMP_LOGIN } from "@/store/modules/user/actions";

const store = useStore();
const isLogin = computed(() => store.state.user.isLogin);
const username = computed(() => store.state.user.username);
const hideLogin = computed(() => store.state.survey.hideLogin);
const handleLogout = () => {
  store.dispatch(`user/${LOGOUT}`);
};

const handleJumpLogin = () => {
  store.dispatch(`user/${JUMP_LOGIN}`);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/dimen.scss";

.userBox {
  font-size: 20px;
  color: $themeFontColor;
  display: flex;
  align-items: center;
  white-space: nowrap;
  @media (orientation: landscape) {
    font-size: 20px;
  }
}
.icon {
  width: 30px;
  height: 29px;
  background: url($imgURL + "user_icon.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 10px;
  @media (orientation: landscape) {
    width: 30px;
    height: 29px;
  }
}
.username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
  @media (orientation: portrait) {
    max-width: 300px;
  }
}
.switchAccount,
.login {
  color: $themeFontColor;
  margin-left: 10px;
  cursor: pointer;
  @media (orientation: landscape) {
    margin-left: 10px;
  }
}
</style>
